import { useToast } from '@urbanx/agx.ui-components2';
import { useTaskCreatedEvent } from 'hooks/useTaskCreatedEvent';
import { useCallback, useEffect, useState } from 'react';

const newTaskNotificationId = 'new-task-notification';

export const useNewTaskNotifier = (onRefreshClicked: () => void) => {
  const [newTasks, setNewTasks] = useState(1);

  const { pushToast, removeToast } = useToast();

  const onRefresh = useCallback(() => {
    onRefreshClicked();
    setNewTasks(1);
  }, [onRefreshClicked]);

  const onTaskCreatedReceived = useCallback(() => {
    const pluralText = newTasks === 1 ? 'is' : 'are';
    const suffix = newTasks === 1 ? '' : 's';

    pushToast(
      {
        message: `There ${pluralText} ${newTasks} new task${suffix}`,
        action: {
          label: 'Refresh',
          onClick: onRefresh,
        },
      },
      newTaskNotificationId
    );
    setNewTasks((count) => count + 1);
  }, [newTasks, onRefresh]);

  useTaskCreatedEvent(onTaskCreatedReceived);

  useEffect(() => {
    return () => {
      removeToast(newTaskNotificationId);
    };
  }, []);
};
